export default "__VITE_ASSET__BSnt_aX0__"